const promotionDetailsCols = ['selection', 'ean', 'groupId', 'id', 'sapPromoId', 'title', 'type'];

export default promotionDetailsCols;
